import { Link, useLocation } from 'react-router-dom';
import {
  HomeIcon,
  Cog6ToothIcon,
  UserCircleIcon,
  ServerIcon,
  FolderIcon
} from '@heroicons/react/24/solid';
import logo from '../assets/logo.svg';
import { useAuth } from './AuthContext';

interface SidebarProps {
  isMobileMenuOpen: boolean;
  setIsMobileMenuOpen: (open: boolean) => void;
}

const Sidebar: React.FC<SidebarProps> = () => {
  const location = useLocation();
  const { user, logout } = useAuth();

  const navigation = [
    { name: 'Home', href: '/', icon: HomeIcon },
    { name: 'HAProxy', href: '/haproxy', icon: ServerIcon },
    { name: 'NFS', href: '/nfs', icon: FolderIcon },
    { name: 'Settings', href: '/settings', icon: Cog6ToothIcon },
  ];

  return (
    <div className="fixed inset-y-0 left-0 flex w-64 flex-col bg-zinc-800/50">
      <div className="flex h-24 shrink-0 items-center border-b border-white/5 px-6">
        <img
          className="h-20 w-auto"
          src={logo}
          alt="Netops Logo"
        />
      </div>
      

      
      <div className="flex flex-1 flex-col gap-y-7 overflow-y-auto px-6 py-6">
        <nav className="flex-1">
          <div className="space-y-1">
            {navigation.map((item) => {
              const isActive = location.pathname === item.href || 
                (item.href !== '/' && location.pathname.startsWith(item.href));
              return (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`flex items-center gap-x-3 rounded-md px-3 py-2 text-sm font-medium ${
                    isActive ? 'bg-zinc-800 text-white' : 'text-zinc-400 hover:bg-zinc-800 hover:text-white'
                  }`}
                >
                  <item.icon
                    className={`h-6 w-6 shrink-0 ${isActive ? 'text-white' : 'text-zinc-400'}`}
                    aria-hidden="true"
                  />
                  {item.name}
                </Link>
              );
            })}
          </div>
        </nav>
      </div>

      <div className="mt-auto border-t border-white/5 px-3 py-3">
        <div className="flex w-full items-center gap-x-3 rounded-md px-3 py-2 text-sm font-medium text-zinc-400">
          <UserCircleIcon className="h-8 w-8 rounded-full bg-zinc-800 p-1" aria-hidden="true" />
          <div className="flex flex-col items-start">
            <span className="text-sm font-medium text-zinc-400">{user?.username || 'admin'}</span>
          </div>
          <button
            onClick={() => { logout(); window.location.reload(); }}
            className="ml-auto text-xs font-semibold text-red-500 hover:text-red-700 px-2 py-1 rounded transition-colors"
          >
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
};

export default Sidebar; 